import styled from "styled-components";
import { colors } from "../styles";
import { PlusOutlined } from '@ant-design/icons';

export const FloatingButton = ({ onClick }) => {
  return (
    <StyledButton onClick={onClick}>
      <PlusOutlined style={{ fontSize: '24px' }} />
    </StyledButton>
  );
};

const StyledButton = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${colors.secondary};
  color: ${colors.white};
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 12px ${colors.shadow};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  
  &:hover {
    transform: scale(1.1);
    background-color: ${colors.accent};
    box-shadow: 0 6px 16px ${colors.shadow};
  }
`;
